// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
  showError,
  showToast,
  Loader,
  STORAGE_KEYS,
} from "../../constants";
import { usePostLoginMutation } from "../../services/auth";
import { useAppDispatch } from "../../hooks/store";
import { setCredentials } from "../../reducers/authSlice";
import PhoneInput from "react-phone-input-2";


const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isEmail, setIsEmail] = useState(true);
  const [loginApi, { isLoading }] = usePostLoginMutation();

  const [showPassword1, setShowPassword1] = useState(false);
  const handleClickShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };
  const handleMouseDownPassword1 = (event: any) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };
  const handleMouseDownPassword2 = (event: any) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      phone: "",
      password: "",
      remember: false,
      remember2: false,
      countryCode: "+1",
      countryName: "US",
    },
    validationSchema: Yup.object({
      remember: Yup.boolean(),
      remember2: Yup.boolean(),
      email: isEmail
        ? Yup.string()
          .required("Email is required")
          .matches(
            /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            "Enter a valid email address!"
          )
        : Yup.string().notRequired(),
      phone: isEmail
        ? Yup.string().notRequired()
        : Yup.string()
          .typeError("That doesn't look like a phone number")
          .min(6)
          .max(16)
          .required("A phone number is required"),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password should be min 6 letters"),
    }),

    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      
      const fcmtoken = getFromStorage(STORAGE_KEYS.fcmToken);
      console.log(fcmtoken,"fcm in login body");
      
      let body = {
        ...(isEmail ? { email: values.email } : { phone_number: values.phone }),
        password: formik.values.password,
        ...(!isEmail ? { country_code: values.countryCode } : {}),
        ...(!isEmail ? { country_name: values.countryName } : {}),
        deviceType: "WEB",
        deviceToken: fcmtoken || "1234"
      };
      console.log(body,"login ki body");
      
      let data = {
        phone_number: values.phone,
        password: formik.values.password,
        country_code: values.countryCode,
      };
      let data2 = {
        email: values.email,
        password: formik.values.password,
      };

      console.log(body,"body for login");
      try {
        const response = await loginApi(body).unwrap();
        if (response?.status === 200) {
          showToast("Login Successfully.");
          setToStorage(STORAGE_KEYS.token, response?.token || "");
          setToStorage(STORAGE_KEYS.userId, response?.user?.id || "");
          dispatch(
            setCredentials({
              user: response?.user || null,
              token: response?.token || null,
            })
          );
          if (formik?.values?.remember) {
            setToStorage(STORAGE_KEYS.phoneCredentials, JSON.stringify(data));
          } else {
            removeFromStorage(STORAGE_KEYS.phoneCredentials);
          }

          if (formik?.values?.remember2) {
            setToStorage(STORAGE_KEYS.credentials, JSON.stringify(data2));
          } else {
            removeFromStorage(STORAGE_KEYS.credentials);
          }

          navigate("/", { replace: true });
        }
      } catch (error: any) {
        showError("Invalid credentials" || "");
      }
    },
  });

  const handleChangePhone = (phone: any, country: any) => {
    // formik.setFieldValue("phone", val);
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    formik.setFieldValue(
      "countryCode",
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
    formik.setFieldValue("countryName", country?.countryCode.toUpperCase());
  };

  useEffect(() => {
    const data = getFromStorage(STORAGE_KEYS.phoneCredentials);
    if (data) {
      const rememberData = JSON.parse(`${data}`);
      formik.setFieldValue("countryCode", rememberData?.country_code);
      formik.setFieldValue("phone", rememberData?.phone_number);
      formik.setFieldValue("password", rememberData?.password);
      // formik.setFieldValue("email", rememberData?.email);
      formik.setFieldValue("remember", true);
    }
  }, []);


  useEffect(() => {
    const data = getFromStorage(STORAGE_KEYS.credentials);
    console.log(data, "dddd");
    if (data) {
      const rememberData = JSON.parse(`${data}`);
      // formik.setFieldValue("countryCode", rememberData?.countryCode);
      // formik.setFieldValue("phone", rememberData?.phone_number);
      formik.setFieldValue("password", rememberData?.password);
      formik.setFieldValue("email", rememberData?.email);
      formik.setFieldValue("remember2", true);
    }
  }, []);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {!isEmail ? (
          <div className="tab-pane">
            <div className="control_group">
              <label>Phone Number</label>
              <PhoneInput
                country={"us"}
                placeholder="0 (000) 000-000"
                enableSearch={true}
                inputStyle={{ width: "100%" }}
                onChange={(phone, country) => handleChangePhone(phone, country)}
                onBlur={formik.handleBlur}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Prevent default behavior (form submission)
                    formik.handleSubmit(); // Manually submit the form
                  }
                }}
                value={formik.values.countryCode + formik.values.phone}
              />
              {formik.touched.phone && formik.errors.phone ? (
                <h6 className="err_msg">
                  {formik.touched.phone && formik.errors.phone}
                </h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <label>Password</label>
              <TextField
                hiddenLabel
                placeholder="Enter Password"
                fullWidth
                className="text_field"
                name="password"
                onChange={(val) => {
                  formik.handleChange(val);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                helperText={formik.touched.password && formik.errors.password}
                type={showPassword1 ? "text" : "password"}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment className="eye_btn" position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword1}
                        edge="end"
                      >
                        {showPassword1 ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="control_group control_group_flex">
              <label className="checkbox_label">
                {/* <Checkbox /> Remember me */}
                <FormControlLabel
                  control={<Checkbox />}
                  label={"Remember me"}
                  checked={formik.values.remember}
                  name="remember"
                  onChange={formik.handleChange}
                />
              </label>
              <p>
                <small>
                  <a
                    href="javascript:void(0)"
                    onClick={() =>
                      navigate("/forgot-password", { state: "phone" })
                    }
                  >
                    Forgot Password ?
                  </a>
                </small>
              </p>
            </div>
          </div>
        ) : (
          <div className="tab-pane">
            <div className="control_group">
              <label>Email</label>
              <TextField
                hiddenLabel
                placeholder="Enter Email"
                className="text_field"
                fullWidth
                name="email"
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                helperText={formik.touched.email && formik.errors.email}
              />
            </div>
            <div className="control_group">
              <label>Password</label>
              <TextField
                hiddenLabel
                placeholder="Enter Password"
                className="text_field"
                fullWidth
                name="password"
                helperText={formik.touched.password && formik.errors.password}
                onChange={(val) => {
                  formik.handleChange(val);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                type={showPassword2 ? "text" : "password"}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment className="eye_btn" position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                        edge="end"
                      >
                        {showPassword2 ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="control_group control_group_flex">
              <label className="checkbox_label">
                <FormControlLabel
                  control={<Checkbox />}
                  label={"Remember me"}
                  checked={formik.values.remember2}
                  name="remember2"
                  onChange={formik.handleChange}
                />
              </label>
              <p>
                <small>
                  <a
                    href="javascript:void(0)"
                    onClick={() =>
                      navigate("/forgot-password", { state: "email" })
                    }
                  >
                    Forgot Password ?
                  </a>
                </small>
              </p>
            </div>
          </div>
        )}
        <div className="form_btn">
          <Button type="submit" className="btnn btn_xsm btn_primary w_100">
            Login
          </Button>
        </div>
      </form>

      <div className="text_tabs">
        {!isEmail ? (
          <Button
            className="nav-link"
            type="button"
            onClick={() => setIsEmail(true)}
          >
            Sign in with email
          </Button>
        ) : (
          <Button
            className="nav-link"
            type="button"
            onClick={() => setIsEmail(false)}
          >
            Sign in with phone number
          </Button>
        )}
      </div>
    </>
  );
};

export default SignIn;
